import React from 'react';

import Accordion from 'react-bootstrap/Accordion';
import { BulletinMessages } from '../types';
import SystemAccordion from './SystemAccordion';

interface FlagTreeProps {
  bulletinMessages: BulletinMessages;
}

function FlagTree({ bulletinMessages }: FlagTreeProps) {
  if (bulletinMessages.systems.length === 0) {
    return <p>No Messages set</p>;
  }

  return (
    <Accordion defaultActiveKey="0">
      {bulletinMessages.systems.map((system, index) => (
        <SystemAccordion key={system.name} system={system} index={index} />
      ))}
    </Accordion>
  );
}

export default FlagTree;
